<template>
    <img
        :alt="countryName"
        class="flag-icon"
        :src="flags?.get(iso2)"
    />
</template>

<script setup lang="ts">
import type { CountryCode } from 'libphonenumber-js';
import { ref } from 'vue';

const flags = ref<Map<CountryCode, string>>();
import('./CountryFlags').then(({ countryFlags }) => {
    flags.value = countryFlags;
});

defineProps<{
    iso2: CountryCode;
    countryName: string;
}>();
</script>

<style scoped lang="scss">
.flag-icon {
    @apply h-4 w-6 overflow-hidden rounded-sm object-cover object-center;
}
</style>
